<template>
    <PatientRowCells :patient="patient" class="table-tr">
        <span :id="`patient-${patient.id}`" class="patient-anchor"></span>

        <div class="table-td cell-length">
            <figure class="patient-icon tooltip tooltip-hover">
                <template v-if="patient.my_doctor && patient.my_doctor.institution">
                    <img :src="patient.my_doctor.institution.icon" :alt="patient.my_doctor.institution.name" />
                    <div class="tooltip-content content-width left">
                        <p>{{ patient.my_doctor.institution.name }}</p>
                    </div>
                </template>
                <template v-else>
                    <svg-icon icon="institution.doctor" />
                    <div class="tooltip-content content-width left">
                        <p>{{ __('General practitioner') }} / {{ __('Diabetologist') }}</p>
                    </div>
                </template>
            </figure>

            <a :href="`/pacient/${patient.id}`">
                <PatientUserImage :patient="patient" unread-messages-count />

                <div class="patient-info">
                    <span class="user-name">
                        <strong>{{ patient.user | fullname }}</strong>
                        {{ patient.age }}

                        <figure v-if="patient.has_active_note_reminders" class="patient-alert">
                            <svg-icon icon="icon-alert" />
                        </figure>
                    </span>

                    <PatientProgress :patient="patient" />
                </div>
            </a>
        </div>
    </PatientRowCells>
</template>

<script>
import PatientRowCells from './PatientRowCells'
import PatientUserImage from '@components/PatientsMatrix/Cells/PatientUserImage'

export default {
    components: {
        PatientRowCells,
        PatientUserImage
    },
    props: {
        patient: {
            type: Object,
            required: true
        }
    }
}
</script>
